import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AuthUserDTO } from "@platform/shared-types";

interface AuthState {
  accessToken: string | null;
  user: AuthUserDTO | null;
  setSession: (accessToken: string, user: AuthUserDTO) => void;
  clearSession: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      user: null,
      setSession: (accessToken, user) => set({ accessToken, user }),
      clearSession: () => set({ accessToken: null, user: null }),
    }),
    {
      name: "nevisign-reader-auth",
      version: 2,
      partialize: (state) => ({ user: state.user }) as AuthState,
      migrate: (persisted) => {
        const safe = (persisted && typeof persisted === "object")
          ? { ...(persisted as Record<string, unknown>) }
          : {};
        delete safe.accessToken;
        return safe as unknown as AuthState;
      },
    },
  ),
);
